// Moteur de recommandation MIROIR du backend (server.py build_recommendation).
// Utilisé uniquement en repli HORS-LIGNE. En ligne, le backend reste la source de vérité.
const SEUIL = 3000;

export function recommendLocal(d, catalog) {
  const byId = catalog.solutionsById || {};
  const rules = catalog.eligibility_rules || [];
  const warnings = [];
  let blocking = false;
  const ids = [];
  const base = (r) => byId[r];

  const result = (extra = {}) => ({
    warnings, blocking, montant: d.montant, recommendations: ids
      .filter((v, i) => ids.indexOf(v) === i)
      .map(base)
      .filter(Boolean),
    eligibility_rules: rules, ...extra,
  });

  if (d.resident_fr === false) {
    return { warnings: [{ level: "ineligible", message: "Le client n'est pas résident français : il n'est pas éligible à un financement." }], blocking: true, montant: d.montant, recommendations: [], eligibility_rules: rules };
  }
  if (d.age != null && (d.age < 18 || d.age > 81)) {
    return { warnings: [{ level: "ineligible", message: `Âge du client (${d.age} ans) hors de la tranche 18 – 81 ans : aucune solution de financement n'est possible. Envisager un paiement comptant ou un co-emprunteur éligible.` }], blocking: true, montant: d.montant, recommendations: [], eligibility_rules: rules };
  }

  let apportPct = null;
  const baseApport = d.prix_remorque || ((d.montant || 0) + (d.apport || 0));
  if (d.apport && baseApport) apportPct = (d.apport / baseApport) * 100;

  const occasionOk5 = d.etat_vehicule === "neuf" || (d.etat_vehicule === "occasion" && d.vehicule_moins_5ans !== false);
  const redirectPart = d.client_type === "pro" && d.pro_anciennete_2ans === false;

  if (d.client_type === "particulier" || redirectPart) {
    if (redirectPart) warnings.push({ level: "warning", message: "Professionnel de moins de 2 ans d'activité : orientation vers un financement PARTICULIER." });
    const ageOk18 = d.age == null || d.age >= 18;
    const bloquee = d.situation === "cdd" || d.situation === "chomage";

    if (ageOk18 && (d.montant <= SEUIL || bloquee)) {
      ids.push("sofinco_conso");
      if (bloquee && d.montant > SEUIL) {
        const ap = d.montant - SEUIL;
        warnings.push({ level: "warning", message: `Besoin de ${d.montant.toFixed(0)} € supérieur à 3 000 €. Proposer un apport de ${ap.toFixed(0)} € : les 3 000 € restants sont financés en 2, 3 ou 4 fois (CB + pièce d'identité valide).` });
      }
    } else if (!ageOk18) {
      warnings.push({ level: "warning", message: "Le paiement en 2, 3 ou 4 fois nécessite un client majeur (18 ans ou plus)." });
    }

    let creditEligible = !bloquee;
    const sofincoClassique = d.montant <= SEUIL ? "sofinco_classique_petit" : "sofinco_classique_grand";

    if (creditEligible && (d.montant > SEUIL || ageOk18)) {
      if (d.etat_vehicule === "neuf") {
        if (d.detention === "longtemps") {
          ids.push(sofincoClassique);
        } else if (d.detention === "renouveler" || d.detention === "incertain") {
          if (d.montant > SEUIL) ids.push("loa_socram");
          else { ids.push(sofincoClassique); warnings.push({ level: "warning", message: "LOA (Socram) réservée aux financements à partir de 3 001 € : crédit classique Sofinco proposé à la place." }); }
        } else {
          ids.push(sofincoClassique);
          if (d.montant > SEUIL) ids.push("loa_socram");
        }
      } else {
        ids.push(sofincoClassique);
        if (d.etat_vehicule === "occasion") warnings.push({ level: "warning", message: "La LOA Socram (particulier) est réservée aux véhicules NEUFS : elle n'est pas proposée ici." });
      }
    }
  } else if (d.client_type === "pro") {
    if (d.montant <= SEUIL) ids.push("sofinco_conso");

    if (d.affilie_msa) {
      const cp = String(d.code_postal || "").replace(/\s/g, "");
      const clemat = ["16", "22", "24", "29", "33", "35", "56"].includes(cp.slice(0, 2));
      const bankMap = { credit_mutuel: clemat ? "msa_credit_mutuel_clemat" : "msa_credit_mutuel", credit_agricole: "msa_credit_agricole", banque_populaire: "msa_banque_populaire" };
      const bankId = occasionOk5 ? bankMap[d.banque] : null;

      let cbOk = true, cbWarn = null;
      if (!occasionOk5) { cbOk = false; cbWarn = { level: "ineligible", message: "Véhicule d'occasion de plus de 5 ans : Crédit-bail (Mutualease) et crédits agricoles MSA non disponibles. Seul le crédit classique Sofinco reste possible." }; }
      else if (d.montant <= SEUIL) { cbOk = false; cbWarn = { level: "warning", message: "Crédit-bail (Mutualease) réservé aux financements à partir de 3 001 € : crédit classique Sofinco proposé à la place." }; }
      else if (apportPct != null && apportPct > 35) { cbOk = false; cbWarn = { level: "warning", message: "Crédit-bail (Mutualease) supprimé (apport supérieur à 35%) : crédit classique Sofinco proposé à la place." }; }

      if (bankId) {
        ids.push(bankId);
        if (cbOk) ids.push("loa_pro_mutualease"); else if (cbWarn) warnings.push(cbWarn);
        ids.push("sofinco_pro");
      } else {
        if (d.detention === "longtemps") ids.push("sofinco_pro");
        else if (d.detention === "renouveler" || d.detention === "incertain") {
          if (cbOk) ids.push("loa_pro_mutualease");
          else { ids.push("sofinco_pro"); if (cbWarn) warnings.push(cbWarn); }
        } else {
          if (cbOk) ids.push("loa_pro_mutualease"); else if (cbWarn) warnings.push(cbWarn);
          ids.push("sofinco_pro");
        }
        if (occasionOk5 && !bankMap[d.banque]) warnings.push({ level: "warning", message: "Banque non précisée : aucun crédit agricole MSA n'est proposé." });
      }
    } else {
      if (d.lien_equestre) {
        if (!occasionOk5) { warnings.push({ level: "warning", message: "Activité équestre : le Crédit-bail Mutualease vise le neuf ou l'occasion de moins de 5 ans. Véhicule trop ancien : crédit classique Sofinco proposé à la place." }); ids.push("sofinco_pro"); }
        else if (d.montant <= SEUIL) { warnings.push({ level: "warning", message: "Crédit-bail (Mutualease) réservé aux financements à partir de 3 001 € : crédit classique Sofinco proposé à la place." }); ids.push("sofinco_pro"); }
        else if (apportPct != null && apportPct > 35) { warnings.push({ level: "warning", message: "Crédit-bail (Mutualease) supprimé (apport supérieur à 35%) : crédit classique Sofinco proposé à la place." }); ids.push("sofinco_pro"); }
        else ids.push("loa_pro_mutualease");
      } else {
        ids.push("sofinco_pro");
      }
    }
  }

  return result();
}

export { SEUIL };
